import { Modal, SxProps } from '@mui/material';
import { FC, ReactNode } from 'react';

import * as Styled from './styled';

interface ModalProps {
	isOpen: boolean;
	handleClose: () => void;
	children: ReactNode;
	sx?: SxProps;
}

export const SharedModal: FC<ModalProps> = ({ isOpen, handleClose, children, sx }) => {
	return (
		<Modal open={isOpen} onClose={handleClose} className="rtl-able">
			<Styled.ModalContent sx={sx}>
				<Styled.ModalCloseButton onClick={handleClose}>
					<span>&times;</span>
				</Styled.ModalCloseButton>
				{children}
			</Styled.ModalContent>
		</Modal>
	);
};
